<template>
<div class="vld-parent" style="width: 100%;height:60%;">
  <span class="date">
  <h1>
    Daily Balance Sheet
  </h1>
  <div>
    <p></p>
  </div>
  </span>
  <p class="clear"></p>
  <v-menu
        v-model="datemenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            dense            
            label="Invoice Date"            
            readonly
            v-bind="attrs"
            v-on="on"
            :value="createdAt"
          ></v-text-field>
        </template>
        <v-date-picker          
          @change="v => {createdAt = v; datemenu=false}"
          @input="createdAt = false"
        ></v-date-picker>
      </v-menu>
       <v-card-actions class="action-box"> 
             <v-row align="center">            
            <v-btn class="action-btn" @click="showReport" type="submit"> View Report</v-btn>
            </v-row>
          </v-card-actions>
<h2> Sale Summary </h2>
  <table>
    <tr>
      <td> </td>
      <th> # of Tickets</th>
      <th> Cost </th>
      <th> Taxes </th>
      <th> Gross </th>
      <th>  A31 </th>
    
    </tr>

    <tr> 
      <th> Totals </th> 
      <td> {{dailyReportData&&dailyReportData.saleSummary[0].no_of_tickets}} </td>
      <td> {{dailyReportData&&dailyReportData.saleSummary[0].sumNetPrice.toFixed(2)}} </td>
      <td> {{dailyReportData&&dailyReportData.saleSummary[0].sumTaxes.toFixed(2)}} </td>
      <td> {{dailyReportData&&dailyReportData.saleSummary[0].sumGross.toFixed(2)}} </td>
      <td> {{dailyReportData&&(dailyReportData.saleSummary[0].sumNetPrice.toFixed(2)-dailyReportData.saleSummary[0].sumGross.toFixed(2)).toFixed(2)}} </td>
    
      </tr>

  </table>

<hr>

<h2> Payments Summary </h2>
<table>
  <tr>
    <th> </th>
    <th> Cash </th>
    <th> Cheque </th>
    <th> Bank Deposit </th>
    <th>Credit Card </th>
  </tr>

  <tr>
    <th>  Customers </th>
  </tr>

  <tr>
    <th> Totals </th>
        <td> {{dailyReportData&&dailyReportData.paymentSummary[0].sumCash.toFixed(2)}} </td>
      <td> {{dailyReportData&&dailyReportData.paymentSummary[0].sumCheque.toFixed(2)}} </td>
      <td> {{dailyReportData&&dailyReportData.paymentSummary[0].sumBank.toFixed(2)}} </td>
      <td> {{dailyReportData&&dailyReportData.paymentSummary[0].sumCard.toFixed(2)}} </td>
  </tr>
</table>

<hr>

<h2>
  Paid In  out Transactions
</h2>

<table class="paidIn">
  <tr>
    <th> Receipt No </th>
    <th>Customer No </th>
    <th> Customer Name </th>
    <th>Cash </th>
    <th> Cheque </th>
    <th> Card </th>
    <th> Bank Deposit </th>
    <th> CR/DB </th>
    <th> Description </th>
    <th> Employee Name </th>
  </tr>
  
    <tr v-for="item in dailyReportData.paidInOutSummary" :key="item.id">
    <td> {{item.id}} </td>
    <td> {{item.customer.id}} </td>
    <td> {{item.customer.name}} </td>
    <td> {{item.cash}} </td>
    <td> {{item.cheque}} </td>
    <td> {{item.card}} </td>
    <td> {{item.bankDeposit}} </td>
    <td> {{item.amountCredit>0?"CR":"DB"}} </td>
    <td> {{item.description}}  </td>
    <td> {{item.user.name}}    </td>
  </tr>
   
</table>  

  <div>
<span class="date">
  <p>
    
  </p>

</span>
  </div>
</div>
</template>

<script>
    import { ledgerService } from './../../services/'        
    import 'vue-loading-overlay/dist/vue-loading.css';

  export default {
    name: 'DailyReport',
    data: () => ({      
       isLoading: true,
        fullPage: true,
        selectedCustomerId:null,
        gridOptions: null,
        tab:null,
         datemenu: false,
        gridApi: null,  
        snackbar: false,
        rowSelection: null,
        dailyReportData:null,
        response:null,
       createdAt:new Date().toISOString().slice(0, 10),
         columnDefs:[          
          { headerName: 'Customer No', field:'customerId'},
          { headerName: 'Customer Name', field:'customer.name'},
          { headerName: 'Acccount Type', field:'customer.type'},
          { headerName: 'City' , field: 'customer.city.name'} ,
          { headerName: 'Postcode' , field: 'customer.postCode'} ,
          { headerName: 'Contact No' , field: 'customer.contactNumber'} ,
          { headerName: 'Credit Limit', field:'customer.creditLimit'},
          { headerName: 'Current Balance', field:'balance',valueFormatter: params => params.data.balance.toFixed(2)},
          { headerName: 'Due Date', field:''},          
        ], 
    }),
    components: {
        
    },    
    methods: { 
      showReport(){
      this.loadTransactions()
      },
      loadTransactions() {
        let self=this        
        self.isLoading=true
        console.log(self.createdAt)
       ledgerService.getDailyReport(self.createdAt).then(dailyReport=> {              
        self.dailyReportData=dailyReport
              self.isLoading=false
        })
    },     
    
    onSelectionChanged() {
      let selectedRows = this.gridApi.getSelectedRows();      
      this.selectedCustomerId=selectedRows[0].customerId;
    },

    },
    beforeMount() {
      this.gridOptions = {};
      this.rowSelection = 'single';
      this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,            
    };
    },
    mounted () {     
        this.gridApi = this.gridOptions.api;   
        this.loadTransactions()        
    }
  }
  
</script>
<style>

.date 
{
  float:right;
  padding-right:10%;
}
.date p
{
  float:right;
}

.vld-parent .v-text-field {         
    width:20%;
    
  }
.vld-parent .v-text-field label
{
  padding-bottom:5%;
  padding-left:5%;
}

.vld-parent .action-btn
{
  float:left;
  margin-left:20%;
}
.vld-parent
{
  padding-left:1%;
}

.vld-parent th
{
  padding:5px;
}

.vld-parent table 
{
  margin-bottom:20px;
  margin-top:2%;
}

hr
{
  border-top:3px solid black;
}

.vld-parent table 
{
  width:100%;
  text-align: left;
}

.vld-parent h2
{
  margin-left:3%;
  margin-top:1%;
}

.paidIn
{
  border-collapse: collapse;
}

.paidIn th 
{
  border-bottom:3px solid black;
  padding:10px;
}

.paidIn tr , .paidIn td
{
  border-bottom:2px solid black;
  padding:10px;
}

.clear
{
  clear:right;
}

.ag-theme-balham .ag-cell .ag-icon {
  display: flex;
  vertical-align:auto  
}

.bottom-panels {
  margin-top:20px
}

.bottom-panel {
  height: 40%;
  bottom:0
}


</style>